export default "__VITE_ASSET__0aea849f__"